import React from "react";
import { convertMinutesToDHMText } from "../../../../../API";
import {
    QuestionnaireItem,
    QuestionnaireProps,
    QuestionStatus
} from "../../service";
import { isTrue } from "../../../../../Utils/filter";
import style from "./index.module.scss";
import useDeviceType from "../../../../../Utils/useDeviceType";

interface BriefInfoProps {
    item: QuestionnaireItem | QuestionnaireProps;
}

export default function BriefInfo({ item }: BriefInfoProps) {
    const { isMobile } = useDeviceType();

    return (
        <div className={style.root}>
            {isMobile && item.questionnaireStatus === QuestionStatus.End && (
                <span className={style.mobileEnd}>[活动已结束]</span>
            )}
            {item.questionnaireStatus === QuestionStatus.End && !isMobile && (
                <span className={style.end}>[活动已结束]</span>
            )}
            <span>活动时长 {convertMinutesToDHMText(item?.validityTime)}</span>
            {item.startTime && <span>开始时间 {item.startTime}</span>}
            {item.endTime && <span>结束时间 {item.endTime}</span>}
            <span>
                {isTrue(item.anonymityFlag) ? "匿名问卷" : "非匿名问卷"}
            </span>
        </div>
    );
}
